export default __webpack_public_path__ + "static/media/CGV.9c2f10f4.pdf";